<template>
  <div class="comment" >
    <div class="comment-user"><i class="iconfont">&#xe65f;</i> 游客</div>
    <div class="comment-content" v-html="comment.content"></div>
    <div class="reply" v-if="comment.reply">
      <div class="author-user">作者</div>
      <div class="comment-content" v-html="comment.reply"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Comment",
  props: {
    id: { type: Number, required: true },
    comment: { type: Object, required: true }
  },
};
</script>
<style>
.comment{
  color:#333;
  line-height: 2em;
}
.comment .iconfont{
  font-size:1em;
}
.comment-content{
  font-size:1.1em;
  text-indent: 1.35em;
  margin-bottom: .3em;
}
.comment-user,.author-user{
  color:#727272;
  font-weight: 400;
  line-height:1em;
  margin:.2em 0;
}
.author-user{
  margin-left:1.35em;
  padding-left:.5em;
  border-left:2px solid #51aa38;
}
</style>